import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Fee from '../../entities/casis/fee'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface FeeState extends ListState<Fee>{
    editModel:Fee;
    
}
class FeeModule extends ListModule<FeeState,any,Fee>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Fee>(),
        loading:false,
        editModel: new Fee(),
        activeList: new Array<Fee>(),
        path: 'fees'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async updateBatch(context: ActionContext<FeeState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.put('/api/fees-batch', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
        async export(context: ActionContext<FeeState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/fees/export', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return reponse.data.result.filename;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: FeeState, model: Fee) {
            state.editModel = model;
            
        }, 
        new(state: FeeState, model: Fee) {
            state.editModel = Object.assign({});
        },
    });
}
const feeModule=new FeeModule();
export default feeModule;
